import segment from './segment';
import datadog from './datadog';
import cookiebot from './cookiebot';

export default {
    cookiebot,
    segment,
    datadog,
};
